import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { isRTLLanguage } from "@/utils/helpers";
import clsx from "clsx";
import { ChevronDown, ChevronUp } from "lucide-react";
import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { MountWhenVisible } from "../MountWhenVisible";
const QuickDonationForm = lazy(() => import("./QuickDonationForm"));

export const QuickDonation = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { i18n } = useTranslation();

  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <DropdownMenu
      dir={isRTLLanguage(i18n.language) ? "rtl" : "ltr"}
      onOpenChange={setIsOpen}
      open={isOpen}
      modal={false}
    >
      <DropdownMenuTrigger asChild>
        <Button
          ref={btnRef}
          className={cn(
            "flex w-full md:w-[180px] justify-between rounded-lg pl-4 pr-3 py-4 text-sm focus:outline-none md:focus:ring-0",
            isOpen ? "opacity-0" : "",
          )}
        >
          <span className="w-full text-start font-bold">{t("quickDonation.title")}</span>
          {isOpen ? (
            <ChevronUp className={cn("ml-auto h-4 w-4")} />
          ) : (
            <ChevronDown className={cn("ml-auto h-4 w-4")} />
          )}
        </Button>
      </DropdownMenuTrigger>
      {btnRef.current && !isMobile ? (
        <DropdownMenuContent
          style={{
            marginTop: `-${btnRef.current.clientHeight}px`,
          }}
          className="w-[426px] border-none bg-background p-6 text-[14px]"
          side="bottom"
          align="end"
          avoidCollisions={false}
          hideWhenDetached={true}
        >
          <MountWhenVisible className="w-full">
            <Suspense fallback={null}>
              <QuickDonationForm setIsOpen={setIsOpen} />
            </Suspense>
          </MountWhenVisible>
        </DropdownMenuContent>
      ) : (
        <div
          className={clsx(
            "fixed inset-0 z-30 flex items-end justify-center bg-black bg-opacity-50",
            {
              hidden: !isOpen,
            },
          )}
        >
          <div className="w-full overflow-hidden rounded-t-2xl bg-background p-6">
            <MountWhenVisible className="w-full">
              <Suspense fallback={null}>
                <QuickDonationForm setIsOpen={setIsOpen} />
              </Suspense>
            </MountWhenVisible>
          </div>
        </div>
      )}
    </DropdownMenu>
  );
};
